module.exports = __webpack_public_path__ + "static/media/main idea.73bf4720.mp3";